import type { APP_SCOPE } from '@nx/constants';
import { getCurrentScope, useToolsConfiguration } from '@nx/state';
import { useLocation } from 'react-router';

export function useCurrentScope(): APP_SCOPE | null {
  const location = useLocation();
  const toolsConfiguration = useToolsConfiguration();
  return getCurrentScope(toolsConfiguration, location);
}
